import {MotorWCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const MotorWCRequestInit = () => {
    return {
        type: MotorWCActionType.MotorWC_INIT
    }
}

export const MotorWCSuccess = (
    objeckt: any
) => {
    return {
        type: MotorWCActionType.MotorWC_INIT,
        objeckt: objeckt
    }
}

export const getMotorWC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            MotorWCSuccess(
                objeckt
            )
        )
    }
}
